import { Banner } from '@sunwebgroup/uds-ui/banner'

export interface AuthErrorBannerProps {
  message: string
}

export function AuthErrorBanner({ message }: AuthErrorBannerProps) {
  return (
    <Banner hasIcon color="danger" size="M" contentIsCentered>
      <Banner.TextsWrapper>
        <Banner.Text>{message}</Banner.Text>
      </Banner.TextsWrapper>
    </Banner>
  )
}
